<template>
  <!-- Code copied and modifed from legacy SyncLoading.vue -->
  <div class="relative flex items-center ml-2 sm:ml-5 sync-loading-container">
    <aha-spinner v-if="$store.state.isSyncing === 1" />
    <div v-else class="relative">
      <div
        class="flex items-center circle-check-item"
        v-if="$store.state.isSyncing === 2"
        v-tooltip="$i18nPresenter.t('All changes saved')"
      >
        <aha-icon
          class="text-green-50"
          name="circle-check"
          viewBox="0 0 24 24"
          width="16"
          height="16"
        />
      </div>

      <div
        class="error-icon"
        v-if="isRedAlertVisible"
        @click="handleOpenRedAlert()"
      >
        <aha-icon name="error" maintainColor />
      </div>
      <div
        class="sync-error"
        :class="{'in-demo-mode': isGuestUser}"
        v-if="isRedAlertVisible && errorAlertVisible"
      >
        <div class="arrow-box">
          <div class="arrow-box__content">
            <strong>{{ $i18nPresenter.t('Something happened…') }}</strong>
            <aha-icon
              name="close"
              height="15"
              width="15"
              viewBox="0 0 24 24"
              class="cursor-pointer text-base-70 hover:text-primary-90"
              @click="handleCloseRedAlert()"
            />
          </div>
          <p class="mt-1">
            {{ $i18nPresenter.t('No worries.') }}
            <a
              @click="reload()"
              class="arrow-box__reload"
            >
              {{ $i18nPresenter.t('Refresh') }}</a> {{ $i18nPresenter.t(' and check the last change you made.') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  data() {
    return {
      waitPresenting: false,
      showModalQuizReminder: false,
      dataConfirm: {},
      isSwitchingPrivateMode: false,
      errorAlertVisible: true,
    }
  },

  computed: {
    ...mapState({
      isGuestUser: (state) => state.currentUser.isGuest,
    }),

    isRedAlertVisible() {
      return this.$store.state.isSyncing === 3
    },
  },

  watch: {
    isRedAlertVisible(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Red Alert > Modal shown',
        )
      }
    },
  },

  methods: {
    reload() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Red Alert > Reload page',
      )
      window.location.reload()
    },
    handleOpenRedAlert() {
      this.errorAlertVisible = true
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Red Alert > Click to open modal',
      )
    },

    handleCloseRedAlert() {
      this.errorAlertVisible = false
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Red Alert > Close modal',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.sync-error {
  @apply absolute w-60 z-10;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.05em;

  @media screen and (max-width: 480px) {
    &.in-demo-mode {
      left: 40%;
      top: 5.5rem;
    }
  }

  @media (min-width: 480px) { // xs screens and up
    @apply absolute;
  }
}

.error-icon {
  @apply flex items-center cursor-pointer;
}

.arrow-box {
  @apply relative bg-yellow-10 p-2.5 rounded pt-2 shadow-md border border-yellow-100;
  .arrow-box__content {
    @apply flex justify-between;
  }
  .arrow-box__reload {
    @apply font-bold cursor-pointer text-base-90 hover:text-base-80;
    text-decoration: underline !important;
  }
}
.arrow-box:before {
  top: 10px;
  left: 51%;
  border: 5px solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 80, 80, 0);
  border-bottom-color: #FF922E;
  margin-left: -8px;

  @media (min-width: 480px) { // xs screens and up
    top: -11px;
  }
}
.arrow-box:after {
  top: 10px;
  left: 51%;
  border: 5px solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 80, 80, 0);
  border-bottom-color: #FFF7EA;
  margin-left: -8px;
  z-index: 11; // .sync-error z-index = 10

  @media (min-width: 480px) { // xs screens and up
    top: -10px;
  }
}

.sync-loading-container {
  min-width: 24px;
  margin-left: 12px;
}

.circle-check-item{
  padding: 4px;
  &:hover{
    background: #EFF1F7;
    border-radius: 3px;
  }
}
</style>
